import { h } from 'preact';

import './styles/ActionModalHeader.css';

const ActionModalHeader = ({ headerTitle, closeTab }) => {
  return (
    <div id="liana-modal-header">
      <div className="liana-modal-headerTitle liana-text-base">{headerTitle}</div>

      <svg
        onClick={closeTab}
        className="liana-close-modal-icon"
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        tabIndex={0}
        role="button"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.09784 0.730379C1.48837 0.339863 2.12154 0.339875 2.51205 0.730407L7.90237 6.12094L13.2929 0.730624C13.6834 0.340107 14.3166 0.34012 14.7071 0.730652C15.0976 1.12118 15.0976 1.75435 14.7071 2.14487L9.31656 7.53519L14.7069 12.9257C15.0974 13.3163 15.0974 13.9494 14.7068 14.3399C14.3163 14.7305 13.6832 14.7304 13.2926 14.3399L7.90232 8.94937L2.51178 14.3397C2.12125 14.7302 1.48808 14.7302 1.09757 14.3397C0.70705 13.9491 0.707063 13.316 1.09759 12.9254L6.48813 7.53513L1.09781 2.14459C0.707294 1.75406 0.707307 1.1209 1.09784 0.730379Z"
          fill="white"
        />
      </svg>
    </div>
  );
};

export default ActionModalHeader;
